import { TemplateNodeTypeEnum } from '@ulysses-inc/harami_api_client'
import { computeIfAbsent } from '~/utils/map'
import type { ReportNodeSchema } from '@ulysses-inc/harami_api_client'

/**
 * NodePathDict と同じような構造で、ある node までのパス情報を格納する。
 * 末尾の要素は、自 node の node.id となる。
 * ページのID は含まないので、先頭の要素はページ直下の node.id となる。
 */
export type NodeIdPath = number[]

export type ArgPage = {
  id?: number
  nodes?: {
    id: number
  }[]
}

// 繰り返しセクションのマスターであるかの判定をやや厳密にやる関数
//
// ここでは、処理系で使用する情報は最低限検証しておく意図で、
// isMasterSection より厳密な判定としている
const isMasterSectionNodeStrict = (node: ReportNodeSchema) => {
  return (
    node.uuid &&
    node.type === TemplateNodeTypeEnum.Section &&
    node.section?.isRepeat === 1 &&
    !node.section.originalNodeUuid
  )
}

export const createInitialNodeInfoMaps = (
  pages: ArgPage[],
  normalizedReportNodes: Partial<Record<number, ReportNodeSchema>>,
) => {
  const nodeIdPathsByOriginalNodeUuid = new Map<string, NodeIdPath[]>()
  const parentPageIdByNodeId = new Map<number, number>()
  const parentNodeIdByNodeId = new Map<number, number>()
  const pageDict: Partial<Record<number, { nodes: number[] }>> = {}

  const traverseNodes = (currentNodeId: number, pathToParent: number[]) => {
    const node = normalizedReportNodes[currentNodeId]
    if (!node) {
      return
    }
    const pathToCurrent = [...pathToParent, currentNodeId]
    if (isMasterSectionNodeStrict(node)) {
      computeIfAbsent(
        nodeIdPathsByOriginalNodeUuid,
        node.uuid ?? '',
        () => [],
      ).push(pathToCurrent)
    }
    for (const childNodeId of node.nodes) {
      parentNodeIdByNodeId.set(childNodeId, currentNodeId)
      traverseNodes(childNodeId, pathToCurrent)
    }
  }
  for (const page of pages) {
    if (page.id) {
      pageDict[page.id] = { nodes: page.nodes?.map(node => node.id) ?? [] }
    }
    for (const childNode of page.nodes ?? []) {
      if (page.id) {
        parentPageIdByNodeId.set(childNode.id, page.id)
      }
      traverseNodes(childNode.id, [])
    }
  }

  return {
    nodeIdPathsByOriginalNodeUuid,
    parentPageIdByNodeId,
    parentNodeIdByNodeId,
    pageDict,
  }
}
